import type { SiteLanguage } from "./language";
import { legalDocLanguage, legalDocUrl } from "./legal-docs";

/** A single locale-aware registry prevents global URL overrides from mixing editions. */
export const legalLinks = {
  terms: (language: SiteLanguage) => legalDocUrl(language, "terms"),
  privacy: (language: SiteLanguage) => legalDocUrl(language, "privacy"),
  wallet: (language: SiteLanguage) => legalDocUrl(language, "wallet")
};

/** Document links carry their edition language; the separate support link has no document language. */
export function legalLinkLanguage(href: string, language: SiteLanguage) {
  return href.startsWith("/documentation/") ? legalDocLanguage(language) : undefined;
}
